import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core'
import { AuthenticationService } from '../../../../framework/authentication/services/authentication.service'
import { timedPromise } from '../../../../framework/utilities/timedPromise'
import { MatDialog } from '@angular/material/dialog'
import { LoggedDialogComponent } from './logged-dialog/logged-dialog.component'
import { NG_VALIDATORS } from '@angular/forms'
import { EmailInputComponent } from '../email-input/email-input.component'

@Component({
    selector: 'mg-login-submit',
    templateUrl: './login-submit.component.html',
    styleUrls: ['./login-submit.component.scss'],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => LoginSubmitComponent),
            multi: true,
        },
    ],
})
export class LoginSubmitComponent {
    @ViewChild(EmailInputComponent)
    emailInput: EmailInputComponent

    @Input()
    isLoading: Boolean = false

    @Input()
    disabled: Boolean = false

    @Input()
    submitDisabled: Boolean = false

    @Input()
    pathInLoginEmail: string = ''

    @Input()
    isGhost: boolean = false

    @Output()
    // eslint-disable-next-line @angular-eslint/no-output-native
    submit: EventEmitter<any> = new EventEmitter()

    @Output()
    loginRequested: EventEmitter<any> = new EventEmitter()

    isSigningUp: Boolean = false

    isSubmitting: Boolean = false

    isRequestingLogin: Boolean = false
    userEmailAddress: string = ''
    isPrivacyPolicyAgreedTo: boolean = false
    private knownEmailAdresses: string[] = []

    constructor(private authenticationService: AuthenticationService, public dialog: MatDialog) {
        this.pathInLoginEmail = <any>window ? window.location.pathname : ''
    }

    get isSubmitAllowed(): Boolean {
        return (
            !this.isSubmitting &&
            !this.submitDisabled &&
            !this.disabled &&
            this.isPrivacyPolicyAgreedTo &&
            this.emailInput.componentFormControl.valid
        )
    }

    get userIsLoggedIn(): Boolean {
        return this.authenticationService.isLoggedIn
    }

    public get emailExists(): boolean {
        return this.knownEmailAdresses.indexOf(this.userEmailAddress) > -1
    }

    valid() {
        return this.userIsLoggedIn ? null : { login: false }
    }

    async requestLogin() {
        this.isRequestingLogin = true

        // request a login for the account bound to the email address
        await this.authenticationService.requestLogin(this.userEmailAddress, this.pathInLoginEmail)

        // wait 500ms to enable the email to be delivered
        await timedPromise(500)

        this.isRequestingLogin = false

        this.loginRequested.emit()
    }

    async doSubmit() {
        if (!this.isSubmitAllowed) {
            return
        }

        this.isSubmitting = true

        if (!this.userIsLoggedIn) {
            this.isSigningUp = true
            const { userEmailAddress } = this

            try {
                await this.authenticationService.signup(userEmailAddress)
            } catch (error) {
                // TODO: ? :D
                if (error.message.indexOf('already in use')) {
                    this.requestLogin()

                    this.knownEmailAdresses.push(userEmailAddress)
                    this.isSigningUp = false
                    this.isSubmitting = false
                    this.openDialog()
                    return
                }
            }
        }

        this.submit.emit()

        this.isSigningUp = false
        this.isSubmitting = false
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(LoggedDialogComponent, {})
        dialogRef.componentInstance.emailAddress = this.userEmailAddress
    }
}
